<template>
  <el-dialog :title="$t('common_50000')" width="800px" :visible.sync="visible" :lock-scroll="false" :before-close="close" :close-on-click-modal="false">
    <div class="warp" v-if="page==1">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="top">
        <el-row justify="space-between" type="flex">
          <el-col :span="7">
            <el-form-item :label="$t('common_50001')" prop="cardId" required>
              <el-input v-model="ruleForm.cardId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :class="{'source_err':!isNew}" :label="$t('common_50002')" prop="source" required>
              <el-input v-model="ruleForm.source" :disabled="isPlug"></el-input>
            </el-form-item>
            <el-checkbox v-if="!isNew" class="checkbox_isPlug" size="mini" v-model="isPlug">Plug-and-charge vehicles</el-checkbox>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('common_50003')" prop="number">
              <el-input v-model="ruleForm.number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row justify="space-between" type="flex">
          <el-col :span="7">
            <el-form-item :label="$t('common_50004')" prop="contactName">
              <el-input v-model="ruleForm.contactName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('common_50005')" prop="contactTel">
              <el-input v-model="ruleForm.contactTel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('common_50006')" prop="numberPlate">
              <el-input v-model="ruleForm.numberPlate"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="width:490px;">
            <el-form-item :label="$t('common_50007')" prop="authKey">
              <el-input v-model="ruleForm.authKey"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="footer-warp">
          <el-col :span="3">
            <div class="icon">
              <img src="../assets/img/onlineCard.png">
            </div>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item :label="$t('common_50008')" prop="money">
              <el-input v-model="ruleForm.money"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="2">
            <el-form-item :label="$t('common_50009')" prop="password">
              <el-input v-model="ruleForm.password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </div>
    <div class="card-group" v-if="page==2">
      <div>
        <span>{{$t('common_50010')}}</span>
        <el-select v-model="cardGroup" :placeholder="$t('common_50011')">
          <el-option v-for="item in options" :key="item.id" :label="item.title+`(${item.type==2?'超级卡组':'在线卡组'})`" :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="finish-wrap" v-if="page==3">
      <div>
        <div class="icon-wrap">
          <img src="../assets/img/onlineCard.png">
        </div>
        <h1>{{$t('common_50012')}}</h1>
        <p>{{$t('common_50013')}}<span>{{$t('common_50014')}}</span>{{$t('common_50015')}}<span>{{$t('common_50016')}}</span>{{$t('common_50017')}}</p>
        <div class="list">
          {{$t('common_50018')}}
          <br />
          {{$t('common_50019')}}
          <br />
          {{$t('common_50020')}}
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button round v-if="page==2" size="medium" @click="preStep" style="margin-right:20px;">{{$t('common_50021')}}</el-button>
      <el-button round type="primary" size="medium" @click="nextStep">{{page==3?$t('common_50023'):$t('common_50022')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  requestUrl,
  ajax,
  getQueryString,
  generateMixed,
  checkLogin,
  formmatTime,
  getBjTimeFromLocalTime,
} from "@/assets/utils/network";
export default {
  props: {
    visible: Boolean,
    options: Array,
    product: String,
    hasGroupId: Boolean,
    isNew: String,
  },
  data() {
    return {
      currencyType: "",
      isPlug: false, // 是否是即插即充卡
      page: 1,
      ruleForm: {
        cardId: "",
        source: "",
        number: "",
        contactName: "",
        contactTel: "",
        numberPlate: "",
        authKey: "",
        money: "",
        password: "",
      },
      rules: {
        cardId: [{ required: true, message: "", trigger: "blur" }],
        source: [{ required: true, message: "", trigger: "blur" }],
      },
      cardGroup: "", //所选卡组
      infoData: {}, // 创建身份卡所需参数
    };
  },
  watch: {
    isPlug(val) {
      val
        ? (this.ruleForm.source = "Plug-and-charge vehicles")
        : (this.ruleForm.source = "");
    },
    isNew(val) {
      if (val == "idCard") {
        this.isPlug = false;
      } else if (val == "plugCard") {
        this.isPlug = true;
      }
    },
  },
  methods: {
    // 录入---下一步
    nextStep() {
      if (this.page == 3) {
        this.close();
        location.reload();
        return;
      } else if (this.page == 1) {
        const info = {};
        if (this.ruleForm.cardId == "") {
          this.$message.error(this.$t("common_50024"));
          return false;
        }
        let reg =
          /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]{1}[A-Z]{1}[A-Z0-9]{4,5}[A-Z0-9挂学警港澳]{1}$/;
        if (!reg.test(this.ruleForm.cardId)) {
          info.idInput = this.ruleForm.cardId
            .toLowerCase()
            .replace(/[^0-9a-z]+/g, "");
        } else {
          info.idInput = this.ruleForm.cardId;
        }
        if (info.idInput == "") {
          this.$message.error(this.$t("common_50025"));
          return false;
        }
        // let regs = new RegExp("[\\u4E00-\\u9FFF]+", "g");
        // if (regs.test(this.ruleForm.cardId)) {
        //   this.$message.error(this.$t("managementCharger_00070"));
        //   return false;
        // }
        if (this.ruleForm.source == "") {
          this.$message.error(this.$t("common_50026"));
          return false;
        }
        if (
          !this.isPlug &&
          ["Plug-and-charge vehicles", "即插即充", "PlugAndCharge"].includes(
            this.ruleForm.source
          )
        ) {
          this.$message.error(this.$t("common_50033"));
          this.loading = false;
          return false;
        }
        if (this.ruleForm.numberPlate && !reg.test(this.ruleForm.numberPlate)) {
          this.$message.error(this.$t("common_50027"));
          return false;
        }
        let regPhone =
          /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (
          this.ruleForm.contactTel &&
          !regPhone.test(this.ruleForm.contactTel)
        ) {
          this.$message.error(this.$t("common_50031"));
          return false;
        }
        if (
          this.ruleForm.money != "" &&
          (isNaN(this.ruleForm.money) || this.ruleForm.money < 0)
        ) {
          this.$message.error(this.$t("common_50028"));
          return false;
        }
        if (this.ruleForm.money != "" && !this.ruleForm.password) {
          this.$message.error(this.$t("common_50029"));
          return false;
        }
        info.type = "U3";
        info.idInput = this.ruleForm.cardId;
        info.contactName = this.ruleForm.contactName;
        info.number = this.ruleForm.number;
        info.contactMobile = this.ruleForm.contactTel;
        info.authKey = this.ruleForm.authKey;
        info.inUse = true;
        info.source = this.isPlug ? "PlugAndCharge" : this.ruleForm.source;
        info.licenseNo = this.ruleForm.numberPlate;
        this.infoData = info;
        if (this.hasGroupId) {
          this.infoData.groupId = getQueryString("id");
          this.ajaxFn();
        } else {
          this.page = 2;
        }
      } else if (this.page == 2) {
        if (!this.cardGroup) {
          this.$message.error(this.$t("common_50032"));
          return;
        }
        this.infoData.groupId = this.cardGroup;
        if (!this.hasGroupId) {
          this.ajaxFn();
        }
      }
    },
    ajaxFn() {
      ajax({
        //信息入库，获取卡ID
        type: "POST",
        url: requestUrl + "/nfccard",
        dataType: "json",
        data: JSON.stringify(this.infoData),
        success: (response) => {
          var rec = JSON.parse(response);
          if (rec.error != null) {
            if (rec.error.code == "NOT_LOGIN") {
              window.location.href = "./login.html?l=0";
            }
            this.$message.error(
              rec.error.msg == null ? rec.error.code : rec.error.msg
            );
          } else {
            var card = rec.result;
            if (this.ruleForm.money != "") {
              var request = new Object();
              request.id = card;
              request.amount = this.ruleForm.money * 100;
              request.balance = 0;
              request.password = this.ruleForm.password;
              ajax({
                type: "POST",
                url: requestUrl + "/nfccard/charge",
                data: JSON.stringify(request),
                success: function (response) {
                  let rec = JSON.parse(response);
                  if (rec.error != null) {
                    this.$message.error(
                      rec.error.msg == null ? rec.error.code : rec.error.msg
                    );
                  } else {
                    this.$message({
                      message: this.$t("common_50030"),
                      type: "success",
                    });
                    this.page = 3;
                  }
                },
              });
            } else {
              this.$message({
                message: this.$t("common_50030"),
                type: "success",
              });
              this.page = 3;
            }
          }
        },
      });
    },
    // 上一步
    preStep() {
      this.page = 1;
    },
    // 关闭弹窗
    close: function () {
      this.page = 1;
      this.$emit("close", false);
    },
  },
  created: function () {
    var currency = checkLogin("currencyType");
    this.currencyType = currency ? currency : "cny";
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  border-radius: 4px;
  .el-dialog__header {
    border-radius: 4px 4px 0 0;
    background-color: #eff2f6;
    .el-dialog__title {
      font-weight: 600;
      color: #8087a0;
      font-size: 16px;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
}
/deep/.el-dialog__headerbtn .el-dialog__close {
  font-size: 20px;
  color: #8087a0;
}
/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
}
/deep/ .el-form-item {
  margin-bottom: 0;
}
.source_err {
  /deep/.el-form-item__error {
    display: none;
  }
}
.checkbox_isPlug {
  margin-top: 12px;
}
img {
  width: 100%;
}
.footer-warp {
  border-top: 1px dashed #e6e7ec;
  margin-top: 30px;
  padding-top: 20px;
  .icon {
    font-size: 80px;
  }
}
.card-group {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  > div {
    > span {
      padding-bottom: 10px;
      margin-right: 20px;
    }
  }
}
.finish-wrap {
  padding-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  .icon-wrap {
    text-align: center;
    width: 120px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  h1 {
    font-weight: 600;
    color: #1b2330;
    font-size: 24px;
    text-align: center;
    margin: 20px 0;
  }
  p,
  .list {
    color: #1c2237;
    font-size: 14px;
  }
  p {
    margin-bottom: 20px;
    > span {
      color: #5278e2;
    }
  }
  .list {
    line-height: 1.8;
  }
}
.el-row {
  margin: 10px 0;
}
</style>
